<template>
  <div style="width: 100%;height: 100%;background: #ecf0fa;display: flex;justify-content: flex-end;align-items: center;box-shadow: 1px 1px 10px #d3d3d3;">
    <div style="width: calc(100% - 6px);height: calc(100% - 12px);background: white;border-radius: 2px;display: flex;flex-direction: column;">
      <!-- 内容区域（无标题栏） -->
      <div style="flex: 1;width: 100%;background: white;overflow-y: auto;display: flex;flex-direction: column;min-height: 0;">
        <div style="display: flex;flex-direction: column;overflow-y: auto;padding: 10px;flex: 1;background: #ecf0fa22;">
          <slot></slot>
        </div>
        <!-- 底部操作栏（如有确认/取消按钮） -->
        <div style="width: 100%;height: 50px;display: flex;align-items: center;border-top: 1px solid #ecf0fa;flex-shrink: 0;" v-if="onConfirm || onCancel">
          <el-button @click="onConfirm" style="margin-left: 15px;" type="primary" icon="Promotion">确定</el-button>
          <el-button @click="onCancel" style="margin-left: 15px;" type="info" plain icon="Close">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },    // 保留但不显示，避免父组件传值报错
    returnBtn: { type: Boolean, default: false },
    onConfirm: { type: Function, default: null },
    onCancel: { type: Function, default: null },
  },
  methods: {
    goBack() { this.$router.back(); },
  },
};
</script>

<style>
</style>